import React, { useState, useContext } from "react";
import { NavLink } from "react-router-dom";
import Switch from "react-switch";
//pages & includes
import ManageSidebar from "../ManageSidebar";
//functions
import {
  _t,
  getCookie,
  pagination,
  paginationLoading,
  showingData,
  searchedShowingData,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const LocationList = () => {
  let {
    //common
    loading,
    setLoading,
  } = useContext(SettingsContext);

  let {
    //location
    setPaginatedLocation,
    locationList,
    locationForSearch,
    setLocationList,
    setLocationForSearch,
    //pagination
    dataPaginating,
  } = useContext(RestaurantContext);

  // States hook here

  //search result
  let [searched, setSearched] = useState({
    list: null,
    searched: false,
  });

  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearched({ ...searched, searched: false });
    } else {
      let searchedList = locationForSearch.filter((zone) => {
        let lowerCaseZoneName = zone.name.toLowerCase();
        let lowerCaseZoneCode = zone.code.toLowerCase();
        return (
          lowerCaseZoneName.includes(searchInput) ||
          (lowerCaseZoneCode && lowerCaseZoneCode.includes(searchInput))
        );
      });
      setSearched({
        ...searched,
        list: searchedList,
        searched: true,
      });
    }
  };

  //delete confirmation modal of branch
  const handleDeleteConfirmation = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary rounded"
                onClick={() => {
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button
                className="btn btn-success ml-2 px-3 rounded"
                onClick={onClose}
              >
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  //status update
  const handleUpdateStatus = (item) =>{
  
    let formData = {
      id: item.id,
      status: item.status ? 0 : 1,
    };
    const url = BASE_URL + `/settings/update-status-location`;
    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        
        if(res){
          setLocationList(res.data[0]);
          setLocationForSearch(res.data[1]);
        }
        toast.success(`${_t(t("Reason has been updated"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });

      })
      .catch((error) => {
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  }  

  const { t } = useTranslation();
  return (
    <div>
      <Helmet>
        <title>{_t(t("Location List"))}</title>
      </Helmet>
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="fk-scroll--pos-table-menu" data-simplebar>
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                    <div key="fragment3">
                      {/* next page data spin loading */}
                      <CustomSpinLoader loading={loading || dataPaginating} />
                      {/* spin loading ends */}

                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {!searched.searched
                                  ? _t(t("Location List"))
                                  : _t(t("Search Result"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6 col-lg-7">
                          <div className="row gx-3 align-items-center">
                            <div className="col-md-9 t-mb-15 mb-md-0">
                              <div className="input-group">
                                <div className="form-file">
                                  <input
                                    type="text"
                                    className="form-control border-0 form-control--light-1 rounded-0"
                                    placeholder={_t(t("Search")) + ".."}
                                    onChange={handleSearch}
                                  />
                                </div>
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              </div>
                            </div>

                            <div className="col-md-3 text-md-right">
                              <NavLink
                                to="/dashboard/manage/restaurant/location-add"
                                className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                              >
                                {_t(t("add new"))}
                              </NavLink>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Table */}
                      <div className="table-responsive">
                        <table className="table table-bordered table-hover min-table-height">
                          <thead className="align-middle">
                            <tr>
                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("S/L"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Code"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Name"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Status"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Action"))}
                              </th>
                            </tr>
                          </thead>
                          <tbody className="align-middle">
                            {/* loop here, logic === !search && haveData && haveDataLegnth > 0*/}
                            {!searched.searched
                              ? [
                                  locationList && [
                                    locationList?.data?.length === 0 ? (
                                      <tr className="align-middle">
                                        <td
                                          scope="row"
                                          colSpan="6"
                                          className="xsm-text align-middle text-center"
                                        >
                                          {_t(t("No data available"))}
                                        </td>
                                      </tr>
                                    ) : (Array.isArray(locationList.data) &&
                                      locationList?.data?.map((item, index) => {
                                        return (
                                          <tr
                                            className="align-middle"
                                            key={index}
                                          >
                                            <th
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              {index +
                                                1 +
                                                (locationList.current_page -
                                                  1) *
                                                  locationList.per_page}
                                            </th>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {item.code}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {item.name}
                                            </td>

                                            <td className="text-capitalize align-middle text-center">
                                              <Switch
                                                checked={item?.status}
                                                name="status"
                                                onChange={(e) => {
                                                  handleUpdateStatus(item)
                                                }}
                                                height={22}
                                                width={44}
                                                offColor="#ee5253"
                                              />
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              <NavLink
                                                className="btn btn-primary ml-2 rounded-sm"
                                                to={`/dashboard/manage/restaurant/location-edit/${item.id}`}
                                                style={{
                                                  height: "1.7rem",
                                                  width: "1.7rem",
                                                }}
                                              >
                                                <div className="d-flex align-items-center justify-content-center">
                                                  <i
                                                    className="fa fa-pencil edit-icon"
                                                    aria-hidden="true"
                                                  ></i>
                                                </div>
                                              </NavLink>
                                            </td>
                                          </tr>
                                        );
                                      })
                                    ),
                                  ],
                                ]
                              : [
                                  /* searched data, logic === haveData*/
                                  searched && [
                                    searched.list.length === 0 ? (
                                      <tr className="align-middle">
                                        <td
                                          scope="row"
                                          colSpan="6"
                                          className="xsm-text align-middle text-center"
                                        >
                                          {_t(t("No data available"))}
                                        </td>
                                      </tr>
                                    ) : (
                                      searched.list.map((item, index) => {
                                        return (
                                          <tr
                                            className="align-middle"
                                            key={index}
                                          >
                                            <th
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              {index +
                                                1 +
                                                (locationList.current_page -
                                                  1) *
                                                  locationList.per_page}
                                            </th>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {item.code}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {item.name}
                                            </td>

                                            <td className="text-capitalize align-middle text-center">
                                              <Switch
                                                checked={item?.status}
                                                name="status"
                                                onChange={(e) => {
                                                  handleUpdateStatus(item)
                                                }}
                                                height={22}
                                                width={44}
                                                offColor="#ee5253"
                                              />
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              <NavLink
                                                className="btn btn-primary ml-2 rounded-sm"
                                                to={`/dashboard/manage/restaurant/location-edit/${item.id}`}
                                                style={{
                                                  height: "1.7rem",
                                                  width: "1.7rem",
                                                }}
                                              >
                                                <div className="d-flex align-items-center justify-content-center">
                                                  <i
                                                    className="fa fa-pencil edit-icon"
                                                    aria-hidden="true"
                                                  ></i>
                                                </div>
                                              </NavLink>
                                            </td>
                                          </tr>
                                        );
                                      })
                                    ),
                                  ],
                                ]}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* pagination loading effect */}
              {loading === true
                ? paginationLoading()
                : [
                    // logic === !searched
                    !searched.searched ? (
                      <div key="fragment4">
                        <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                          <div className="row align-items-center t-pl-15 t-pr-15">
                            <div className="col-md-7 t-mb-15 mb-md-0">
                              {/* pagination function */}
                              {pagination(locationList, setPaginatedLocation)}
                            </div>
                            <div className="col-md-5">
                              <ul className="t-list d-flex justify-content-md-end align-items-center">
                                <li className="t-list__item">
                                  <span className="d-inline-block sm-text">
                                    {showingData(locationList)}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      // if searched
                      <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                        <div className="row align-items-center t-pl-15 t-pr-15">
                          <div className="col-md-7 t-mb-15 mb-md-0">
                            <ul className="t-list d-flex">
                              <li className="t-list__item no-pagination-style">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() =>
                                    setSearched({
                                      ...searched,
                                      searched: false,
                                    })
                                  }
                                >
                                  {_t(t("Clear Search"))}
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-5">
                            <ul className="t-list d-flex justify-content-md-end align-items-center">
                              <li className="t-list__item">
                                <span className="d-inline-block sm-text">
                                  {searchedShowingData(
                                    searched,
                                    locationForSearch
                                  )}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ),
                  ]}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LocationList;
